import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { logos, socialMediaUrl } from "../Details";
import "./header.css"

function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const { linkdein, github, twitter } = socialMediaUrl;
    const toggleClass = () => {
        setIsOpen(!isOpen);
    };

    return (
        <header className="container mx-auto md:flex justify-between py-2 max-width">
            <div className="flex justify-between items-center py-2 md:py-10">
                <NavLink to="/Portfolio">
                    <img className="w-14" src={logos.logogradient} alt="logo" />
                </NavLink>
                <div onClick={toggleClass} className="cursor-pointer">
                    <svg
                        className="stroke-dark-heading dark:stroke-white md:hidden"
                        width="25"
                        height="20"
                        viewBox="0 0 16 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1.4375 1.3125H14.5625M1.4375 11.3125H14.5625H1.4375ZM1.4375 6.3125H14.5625H1.4375Z"
                            strokeWidth="1.875"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
            <nav className={` ${!isOpen ? "hidden" : null} text-center md:flex justify-between`}>
                <ul className="dark:text-light-content font-medium md:flex items-center md:space-x-5 md:mr-10">
                    <li className="pb-1 md:pb-0">
                        <NavLink to="/Portfolio" onClick={toggleClass}>
                            <span>Home</span>
                        </NavLink>
                    </li>
                    <li className="pb-1 md:pb-0">
                        <NavLink to="/about" onClick={toggleClass}>
                            <span>About</span>
                        </NavLink>
                    </li>
                    <li className="pb-1 md:pb-0">
                        <NavLink to="/technologies" onClick={toggleClass}>
                            <span>Technologies</span>
                        </NavLink>
                    </li>
                    <li className="pb-1 md:pb-0">
                        <NavLink to="/projects" onClick={toggleClass}>
                            <span>Projects</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/contact" onClick={toggleClass}>
                            <span>Contact</span>
                        </NavLink>
                    </li>
                </ul>
                <ul className="flex justify-evenly items-center my-5 md:my-0 md:space-x-5 md:mr-5">
                    <span>
                        <li>
                            <a href={twitter} target="_blank" rel="noreferrer noopener">
                                <svg
                                    className="dark:fill-light-heading fill-dark-heading"
                                    width="32"
                                    height="32"
                                    viewBox="1 1 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M16.875 1.875C8.59152 1.875 1.875 8.59152 1.875 16.875C1.875 25.1585 8.59152 31.875 16.875 31.875C25.1585 31.875 31.875 25.1585 31.875 16.875C31.875 8.59152 25.1585 1.875 16.875 1.875ZM24.0837 13.1819C24.0937 13.3393 24.0937 13.5033 24.0937 13.6641C24.0937 18.5792 20.3504 24.2411 13.51 24.2411C11.4007 24.2411 9.44531 23.6283 7.79799 22.5737C8.09933 22.6071 8.38728 22.6205 8.69531 22.6205C10.4364 22.6205 12.0368 22.0312 13.3125 21.0335C11.6786 21 10.3058 19.9286 9.83705 18.4554C10.4096 18.5391 10.9252 18.5391 11.5145 18.3884C10.6732 18.2175 9.91699 17.7605 9.37438 17.0953C8.83178 16.43 8.53623 15.5973 8.53795 14.7388V14.692C9.03013 14.9699 9.60938 15.1406 10.2154 15.1641C9.70595 14.8245 9.28814 14.3645 8.99903 13.8249C8.70993 13.2852 8.55845 12.6825 8.55804 12.0703C8.55804 11.3772 8.73884 10.7444 9.06362 10.1953C9.99744 11.3449 11.1627 12.2851 12.4837 12.9548C13.8047 13.6245 15.2518 14.0088 16.731 14.0826C16.2054 11.5547 18.0938 9.50893 20.3638 9.50893C21.4353 9.50893 22.3996 9.95759 23.0792 10.6808C23.9196 10.5234 24.7232 10.2087 25.4397 9.78683C25.1618 10.6473 24.5792 11.3739 23.8058 11.8326C24.5558 11.7522 25.279 11.5446 25.9487 11.2533C25.4431 11.9967 24.8103 12.6562 24.0837 13.1819Z" />
                                </svg>
                            </a>
                        </li>
                    </span>
                    <span>
                        <li>
                            <a href={linkdein} target="_blank" rel="noreferrer noopener">
                                <svg
                                    className="dark:fill-light-heading fill-dark-heading"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M15 0.599976C7.04701 0.599976 0.600006 7.04698 0.600006 15C0.600006 22.953 7.04701 29.4 15 29.4C22.953 29.4 29.4 22.953 29.4 15C29.4 7.04698 22.953 0.599976 15 0.599976ZM11.475 20.9685H8.55901V11.5845H11.475V20.9685ZM9.99901 10.4325C9.07801 10.4325 8.48251 9.77997 8.48251 8.97297C8.48251 8.14948 9.09601 7.51648 10.0365 7.51648C10.977 7.51648 11.553 8.14948 11.571 8.97297C11.571 9.77997 10.977 10.4325 9.99901 10.4325ZM22.125 20.9685H19.209V15.768C19.209 14.5575 18.786 13.7355 17.7315 13.7355C16.926 13.7355 16.4475 14.292 16.236 14.8275C16.158 15.018 16.1385 15.288 16.1385 15.5565V20.967H13.221V14.577C13.221 13.4055 13.1835 12.426 13.1445 11.583H15.678L15.8115 12.8865H15.87C16.254 12.2745 17.1945 11.3715 18.768 11.3715C20.6865 11.3715 22.125 12.657 22.125 15.42V20.9685Z" />
                                </svg>
                            </a>
                        </li>
                    </span>

                    <span>
                        <li>
                            <a href={github} target="_blank" rel="noreferrer noopener">
                                <svg
                                    className="dark:fill-light-heading fill-dark-heading"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15 0C6.7125 0 0 6.7125 0 15C0 21.6375 4.29375 27.2437 10.2563 29.2313C11.0063 29.3625 11.2875 28.9125 11.2875 28.5188C11.2875 28.1625 11.2688 26.9813 11.2688 25.725C7.5 26.4188 6.525 24.8062 6.225 23.9625C6.05625 23.5312 5.325 22.2 4.6875 21.8438C4.1625 21.5625 3.4125 20.8687 4.66875 20.85C5.85 20.8313 6.69375 21.9375 6.975 22.3875C8.325 24.6562 10.4812 24.0187 11.3438 23.625C11.475 22.65 11.8688 21.9937 12.3 21.6187C8.9625 21.2437 5.475 19.95 5.475 14.2125C5.475 12.5813 6.05625 11.2313 7.0125 10.1813C6.8625 9.80625 6.3375 8.26875 7.1625 6.20625C7.1625 6.20625 8.41875 5.8125 11.2875 7.74375C12.4875 7.40625 13.7625 7.2375 15.0375 7.2375C16.3125 7.2375 17.5875 7.40625 18.7875 7.74375C21.6562 5.79375 22.9125 6.20625 22.9125 6.20625C23.7375 8.26875 23.2125 9.80625 23.0625 10.1813C24.0188 11.2313 24.6 12.5625 24.6 14.2125C24.6 19.9688 21.0938 21.2437 17.7563 21.6187C18.3 22.0875 18.7688 22.9875 18.7688 24.3937C18.7688 26.4 18.75 28.0125 18.75 28.5188C18.75 28.9125 19.0312 29.3813 19.7812 29.2313C22.759 28.2259 25.3465 26.3121 27.1796 23.7592C29.0127 21.2063 29.9991 18.1429 30 15C30 6.7125 23.2875 0 15 0Z"
                                    />
                                </svg>
                            </a>
                        </li>
                    </span>
                </ul>
            </nav>
        </header>
    );
}

export default Header;
